module.exports = __webpack_public_path__ + "static/assets/71d7fb1f37d132b291c8e2e4f13dcd1b.svg";